export { default } from './SmartGoalsList';
